import { Component, Injector, OnInit } from '@angular/core';
import { ActiveModal, ChassisFormHandler, TenantModel } from '@kaiser-software/chassis-core';
import { LocationModal } from '../location-modal';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';

@Component({
    selector: 'eyewatch-locations-edit-modal',
    templateUrl: 'edit-location.modal.html',
    styleUrls: [ 'edit-location.modal.scss' ]
})
export class EditLocationModal extends LocationModal implements OnInit {

    private title = 'Edit location';

    public pluginData;

    constructor(protected injector: Injector, protected modal: ActiveModal) {
        super(injector, modal);

        const tenant                             = this.modal.get<TenantModel>('tenant');
        this.tenantLocationService.defaultParams = { tenant: tenant.id };
        this.model                               = this.modal.get<TenantModel>('location');

        this.createForm();

        this.pluginData = {
            inputs: {
                modelSubject: Observable.of(this.model),
                form: this.form,
            }
        };
    }

    ngOnInit() {
        super.ngOnInit();

        console.log(this.pluginData);

        this.modal.set('title', this.title);
    }

    private createForm() {
        this.form = new ChassisFormHandler(this.injector, this.tenantLocationService.entityName, this.model);
    }

    protected setSubmitModalButton(buttons) {
        super.setSubmitModalButton(buttons);
        this.setDeleteModalButton(buttons);
    }

    protected setDeleteModalButton(buttons) {
        buttons.after('close', 'delete', {
            text: 'Delete',
            classes: '',
            callback: () => {
                this.modal.dismiss('delete');
            }
        });
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/locations/modals/edit-location/edit-location.modal.ts